/**
 * Alpine.js directive for handling card component logic.
 * Transfers the line-clamp class from the card description element
 * to its rich text child element to ensure proper styling.
 *
 * @param {HTMLElement} el - The root element of the card component.
 * @param {Object} Alpine - The Alpine.js instance.
 */
export default (el, Alpine) => {
    // Effect to transfer line-clamp class from card description to rich text content
    Alpine.effect(() => {
        const cardDescription = el.querySelector("[x-ref='cardDescription']");
        if (!cardDescription) return;

        // Determine if a line-clamp class is present on the card description
        const lineClampClass = getLineClampClass(cardDescription);
        const richText = cardDescription.querySelector(".rich-text");

        // Move the line-clamp class to the rich text child, if both exist
        if (lineClampClass && richText) {
            richText.classList.add(lineClampClass);
            cardDescription.classList.remove(lineClampClass);
        }
    });

    /**
     * Retrieves the first line-clamp class from the given element's class list.
     *
     * @param {Element} targetElement - The DOM element to inspect.
     * @returns {string|null} The line-clamp class if found, otherwise null.
     */
    function getLineClampClass(targetElement) {
        return targetElement
            ? Array.from(targetElement.classList).find(c => c.startsWith("line-clamp-"))
            : null;
    }
};